var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('error-overlay',{attrs:{"error-message":_vm.errorMessage,"show-error":_vm.showError},on:{"hideError":_vm.hideError}}),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }